import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CommonRzmService, ServerConstants} from 'common-domain';
import {AuthService, TldChangeResultVO, InitiateNewDelegationCommand} from 'common-domain';
import {HttpClient} from '@angular/common/http';
import {UserRestEndPoints} from '../../user/services/UserRestEndPoints';

@Injectable({
  providedIn: 'root'
})
export class NewdelegationService extends CommonRzmService {

  constructor(@Inject(HttpClient) http, @Inject('env') environment, @Inject(AuthService) auth) {
    super(http, environment, auth);
  }

  startProcess(newgtld: string, token: string): Observable<any> {
    const url = this.getRestEndPoint() + UserRestEndPoints.NEW_GTLD_LOGIN;
    const initiateNewDelegationCommand: InitiateNewDelegationCommand = {
      tld: newgtld,
      token: token
    };

    return this.getPostResponseUnAuthenticatedRequest<void>(url, initiateNewDelegationCommand);

  }
}
